import { Injectable } from '@angular/core';
import { ApiBaseService } from './api-base.service';

@Injectable({
  providedIn: 'root'
})
export class ProjectInfoService {

  constructor(private service: ApiBaseService) { }

  async getProjectOverview(payload: any): Promise<any> {
    return this.service.httpRequest('ProjectInfoService/GetProjectOverview', payload, true, true);
  }

  async getProjectHeaddata(payload: any): Promise<any> {
    return this.service.httpRequest('ProjectInfoService/GetProjectHeaddata', payload, true, true);
  }

  async getProjectOverviewTaskResults(payload: any): Promise<any> {
    return this.service.httpRequest('ProjectInfoService/GetProjectOverviewTaskResults', payload, true, true);
  }

  async writeProjectHeaddata(payload: any): Promise<any> {
    return this.service.httpRequest('ProjectInfoService/WriteProjectHeaddata', payload, true, true);
  }

  async getGlobalProjectInfo(payload: any): Promise<any> {
    return this.service.httpRequest('ProjectInfoService/GetGlobalProjectInfo', payload, true, false);
  }

  async uploadProjectImageToBlob(payload: any): Promise<any> {
    return this.service.httpRequestForm('ProjectInfoService/UploadProjectImageToBlob', payload, true, true);
  }

  async deleteProjectImage(payload: any): Promise<any> {
    return this.service.httpRequest('ProjectInfoService/DeleteProjectImage', payload, true, true);
  }

  async getProjectCompletionConditions(payload: any): Promise<any> {
    return this.service.httpRequest('ProjectInfoService/GetProjectCompletionConditions', payload, true, true);
  }

  async completeProject(payload: any): Promise<any> {
    return this.service.httpRequest('ProjectInfoService/CompleteProject', payload, true, true);
  }
}
